import { Component, lazy, Suspense, type ReactNode } from "react";
import { ContentLoading } from "./components/ContentLoading";
import { Button } from "./components/ui/button";

const CustomerApp = lazy(() =>
  import("./CustomerApp").then((module) => ({ default: module.CustomerApp })),
);

class WorkspaceLoadBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  override state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  override render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main className="mx-auto max-w-xl space-y-4 p-6 sm:p-8">
        <div role="alert">
          <h1 className="text-xl font-semibold">Couldn’t load the workspace</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            Check your connection and reload to try again.
          </p>
        </div>
        <Button
          onClick={() => {
            window.location.reload();
          }}
        >
          Reload workspace
        </Button>
      </main>
    );
  }
}

export function CustomerAppLoader() {
  return (
    <WorkspaceLoadBoundary>
      <Suspense
        fallback={
          <main className="mx-auto max-w-6xl p-6 sm:p-8">
            <ContentLoading label="Loading workspace…" variant="cards" />
          </main>
        }
      >
        <CustomerApp />
      </Suspense>
    </WorkspaceLoadBoundary>
  );
}
